import { render, staticRenderFns } from "./download-app.vue?vue&type=template&id=2c003d9c&scoped=true"
import script from "./download-app.vue?vue&type=script&lang=js"
export * from "./download-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c003d9c",
  null
  
)

export default component.exports